import React from "react";
import KpiCard from "../../../components/ui-components/KpiCard";

// Headline KPI strip for the Source Connections list — the shared KpiCard tiles,
// left-aligned and matching the /approvals page. Pending/Failed take the amber
// "attention" tone only when there's something to act on, otherwise stay calm.
const ConnectionsSummaryStrip = ({ connections }) => {
  const total = connections.length;
  const verified = connections.filter((c) => c.credential_status === "verified").length;
  const pending = connections.filter((c) => c.credential_status === "pending").length;
  const failed = connections.filter((c) => c.credential_status === "failed").length;

  return (
    <div className="flex flex-wrap gap-4">
      <KpiCard
        className="flex-1 min-w-[200px] max-w-[260px]"
        label="Total connections"
        value={total}
        sub="All source connections"
      />
      <KpiCard
        className="flex-1 min-w-[200px] max-w-[260px]"
        label="Verified"
        value={verified}
        tone="ok"
        sub="Credentials valid"
      />
      <KpiCard
        className="flex-1 min-w-[200px] max-w-[260px]"
        label="Pending"
        value={pending}
        tone={pending > 0 ? "attention" : "neutral"}
        sub="Awaiting validation"
      />
      <KpiCard
        className="flex-1 min-w-[200px] max-w-[260px]"
        label="Failed"
        value={failed}
        tone={failed > 0 ? "attention" : "neutral"}
        sub="Need attention"
      />
    </div>
  );
};

export default ConnectionsSummaryStrip;
